import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useLiveDataQuery } from '../../../../global/blocs/useLiveData'

const GreetingMessage = () => {
  const { data: liveData } = useLiveDataQuery()

  if (!liveData) return null

  return (
    <div className="chat-message">
      <div className="chat-message-header">
        <FormattedMessage
          defaultMessage="Welcome to {webinarName}"
          values={{ webinarName: liveData.name }}
        />
      </div>
      <div className="chat-message-content">
        <FormattedMessage defaultMessage="Hi! There are no chat messages posted yet. Chat messages can be seen by everyone, including the audience of the webinar." />
      </div>
    </div>
  )
}

export { GreetingMessage }
